import React from 'react'


export default function Icon({img, className}) {
    return (
        <div className={className}>
			<img  src={img} alt=""  />
		</div>
    )
}